import { FACILITY_TYPES, SHIP_TYPES, SYSTEM_TYPES } from '@stars-and-ships/core';
import { z } from 'zod';

/** UUIDv7 ids (A-2). */
export const idSchema = z.uuid();
/** ISO-8601 UTC with milliseconds (A-2). */
export const isoDateTimeSchema = z.iso.datetime();

const wholeUnits = z.number().int().nonnegative();

/** Resources and Influence are whole units at the API (`floor(milli / 1000)`, 04 §2.2). */
export const resourcesSchema = z.strictObject({
  metal: wholeUnits,
  gas: wholeUnits,
  supplies: wholeUnits,
});
export type Resources = z.infer<typeof resourcesSchema>;

export const systemTypeSchema = z.enum(SYSTEM_TYPES);
export const facilityTypeSchema = z.enum(FACILITY_TYPES);
export const shipTypeSchema = z.enum(SHIP_TYPES);
export type SystemType = z.infer<typeof systemTypeSchema>;
export type FacilityType = z.infer<typeof facilityTypeSchema>;
export type ShipType = z.infer<typeof shipTypeSchema>;

/** `{ "interceptor": 40 }` — classes with 0 ships are omitted (04 §2.2). */
export const shipCountsSchema = z.partialRecord(shipTypeSchema, z.number().int().positive());
export type ShipCounts = z.infer<typeof shipCountsSchema>;

export const accountRoleSchema = z.enum(['player', 'moderator', 'admin']);
